import axios from 'axios'
import { config } from '../../Constants'
import { parseJwt } from './Helpers'

export const patiApi = {
  authenticate,
  signup,
  numberOfUsers,
  numberOfOrders,
  getUsers,
  deleteUser,
  getOrders,
  deleteOrder,
  createOrder,
  getUserMe,
  contact,
  consentAdd,
  consentReject
}

function authenticate(username: string | null, password: string | null) {
  return instance.post('/auth/authenticate', { username, password }, {
    headers: { 'Content-type': 'application/json' }
  })
}

function signup(user:any) {
  return instance.post('/auth/signup', user, {
    headers: { 'Content-type': 'application/json' }
  })
}

function numberOfUsers() {
  return instance.get('/public/numberOfUsers')
}

function numberOfOrders() {
  return instance.get('/public/numberOfOrders')
}

function getUsers(user:any, username: string | null) {
  const url = username ? `/api/users/${username}` : '/api/users'
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) }
  })
}

function deleteUser(user:any, username: string | null) {
  return instance.delete(`/api/users/${username}`, {
    headers: { 'Authorization': bearerAuth(user) }
  })
}

function getOrders(user:any, text: string | null) {
  const url = text ? `/api/orders?text=${text}` : '/api/orders'
  return instance.get(url, {
    headers: { 'Authorization': bearerAuth(user) }
  })
}

function deleteOrder(user:any, orderId: string | null) {
  return instance.delete(`/api/orders/${orderId}`, {
    headers: { 'Authorization': bearerAuth(user) }
  })
}

function createOrder(user:any, order: string | null) {
  return instance.post('/api/orders', order, {
    headers: {
      'Content-type': 'application/json',
      'Authorization': bearerAuth(user)
    }
  })
}

function getUserMe(user:any) {
  return instance.get('/api/users/me', {
    headers: { 'Authorization': bearerAuth(user) }
  })
}

function contact(form:any) {
	const formData = new FormData(form);
  return instance.post('/public/contact', formData, {
    headers: { 'Content-type': 'application/json' }
  })
}
function consentAdd(id:string,settings:string,duration:number,created:number) {
	let param = "id="+id+"&settings="+settings+"&duration="+duration+"&createdOn="+created; 
	return instance.put('/public/consentAdd', param)
}

function consentReject(id:string,created:number) {
  return instance.put('/public/consentReject', {id,created}, {
    headers: { 'Content-type': 'application/json' }
  })
}

// -- Axios

const instance = axios.create({
  baseURL: config.url.API_BASE_URL
})

instance.interceptors.request.use(function (config) {
  // If token is expired, redirect user to login
  if (config.headers.Authorization) {
    const token = (config.headers.authorization as string).split(' ')[1]
    const data = parseJwt(token)
    if (Date.now() > data.exp * 1000) {
      window.location.href = "/login"
    }
  }
  return config
}, function (error) {
  return Promise.reject(error)
})

// -- Helper functions

function bearerAuth(user:any) {
  return `Bearer ${user.accessToken}`
}